import { IDataGridColumn } from '../../../../common/interfaces/IDataGridColumn';

export const RxDetailsColumns: IDataGridColumn[] = [
  {
    name: 'drugName',
    labelCopy: 'name',
    flexBasis: '20%',
  },
  {
    name: 'severity',
    labelCopy: 'severity',
    sortable: true,
    interactive: true,
    flexBasis: '12.5%',
    sortFn: (a: string, b: string) => {
      const severityOrder = { LOW: 0, MEDIUM: 1, HIGH: 2 };
      return (
        severityOrder[a as keyof typeof severityOrder] -
        severityOrder[b as keyof typeof severityOrder]
      );
    },
  },
  {
    name: 'fillDates',
    labelCopy: 'fill date range',
    interactive: true,
    flexBasis: '20%',
    sortable: true,
    sortFn: (a: any, b: any) => {
      const latestA = a[0];
      const latestB = b[0];

      if (latestA === null) return 1;
      if (latestB === null) return -1;

      return new Date(latestA).getTime() - new Date(latestB).getTime();
    },
  },
  {
    name: 'fills',
    labelCopy: 'fills',
    flexBasis: '8%',
  },
  {
    name: 'quantity',
    labelCopy: 'quantity',
    flexBasis: '12.5%',
  },
  {
    name: 'physician',
    labelCopy: 'physician',
    flexBasis: '20%',
    interactive: true,
  },
  {
    name: 'indications',
    labelCopy: 'indications',
    flexBasis: '20%',
    interactive: true,
  },
];
